import { useState } from 'react';
import { registerMutation, useMutation } from 'data-fetching-client';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { Button } from 'foundations-components/transitional/components/Button';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import unescapedText from 'I18n/utils/unescapedText';
import { CONTENT_PLATFORM_PROPERTY_NAME, useContentObjectType } from 'content-management-data-lib';
import http from 'hub-http/clients/apiClient';
import { getContentId, getContentName } from '../utils/contentUtils';
import { CONTENT_ACTION_IDS } from '../constants/actionIds';
import { useContentActions } from '../providers/ContentActionsProvider';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CloneMutation = registerMutation({
  fieldName: 'cloneContent',
  args: ['contentId', 'contentObjectType'],
  fetcher: ({
    contentId,
    contentObjectType,
    cloneName
  }) => http.post(`content-management/actions/v1/${contentObjectType}/${contentId}/clone`, {
    data: {
      properties: {
        [CONTENT_PLATFORM_PROPERTY_NAME.NAME]: {
          value: cloneName,
          rawValue: cloneName
        }
      }
    }
  })
});
const CloneModal = ({
  crmObjects: [crmObject],
  onClose
}) => {
  const {
    contentObjectType,
    contentObjectTypeSingularNoun
  } = useContentObjectType();
  const [cloneContent, {
    loading
  }] = useMutation(CloneMutation);
  const contentId = getContentId(crmObject);
  const contentName = getContentName(crmObject);
  const [cloneName, setCloneName] = useState(unescapedText('content-management-actions-lib.modals.clone.inputDefaultName', {
    contentName
  }) || '');
  const handleCloneNameChange = ({
    target: {
      value
    }
  }) => {
    setCloneName(value);
  };
  const {
    onActionError,
    onActionSuccess
  } = useContentActions();
  const handleCloneConfirm = () => {
    cloneContent({
      variables: {
        contentId,
        contentObjectType,
        cloneName
      }
    }).then(response => {
      var _response$data;
      if ((_response$data = response.data) !== null && _response$data !== void 0 && _response$data.cloneContent) {
        onActionSuccess({
          actionId: CONTENT_ACTION_IDS.CLONE,
          data: {
            completedResults: [response.data.cloneContent]
          }
        });
      }
    }).catch(error => {
      onActionError({
        actionId: CONTENT_ACTION_IDS.CLONE,
        error,
        data: {
          failedResults: [crmObject]
        }
      });
    });
  };
  return /*#__PURE__*/_jsxs(Modal, {
    "data-test-id": "clone-modal",
    children: [/*#__PURE__*/_jsx(DialogCloseButton, {
      onClick: onClose
    }), /*#__PURE__*/_jsx(DialogHeader, {
      children: /*#__PURE__*/_jsx(Text, {
        as: "h2",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "content-management-actions-lib.modals.clone.header",
          options: {
            contentObjectTypeSingularNoun
          }
        })
      })
    }), /*#__PURE__*/_jsx(DialogBody, {
      children: /*#__PURE__*/_jsx(FormControl, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "content-management-actions-lib.modals.clone.label",
          options: {
            contentObjectTypeSingularNoun
          }
        }),
        children: /*#__PURE__*/_jsx(TextInput, {
          onChange: handleCloneNameChange,
          value: cloneName
        })
      })
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(LoadingButton
      // allows for treating this modal as a UIConfirmModal in Selenium
      , {
        "data-confirm-button": "accept",
        use: "primary",
        onClick: handleCloneConfirm,
        loading: loading,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "content-management-actions-lib.modals.clone.buttons.clone"
        })
      }), /*#__PURE__*/_jsx(Button, {
        use: "secondary",
        onClick: onClose,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "content-management-actions-lib.modals.clone.buttons.cancel"
        })
      })]
    })]
  });
};
export default CloneModal;